import { useEffect, useState } from 'react'
import { useMap } from 'react-leaflet'

/**
 * Waits for Leaflet's internal initialization before rendering children,
 * and cleans up animations on unmount to prevent _leaflet_pos errors.
 */
export const MapReady = ({ children }) => {
  const map = useMap()
  const [ready, setReady] = useState(false)

  useEffect(() => {
    if (map.getSize().x > 0 && map.getSize().y > 0) {
      // Map already has a valid container size — it's ready
      setReady(true)
    } else {
      // Wait for Leaflet to signal readiness
      const onReady = () => setReady(true)
      map.whenReady(onReady)
    }

    return () => {
      // Cleanup: stop animations and detach listeners before DOM is destroyed
      try {
        map.stop()

        // Kill CSS transitions on the map pane so transitionend
        // callbacks cannot fire after the DOM element is removed
        const pane = map.getPane('mapPane')
        if (pane) {
          pane.style.transition = 'none'
          pane.style.transform = ''
        }

        map.off()
      } catch (e) {
        // Ignore errors during cleanup
      }
    }
  }, [map])

  // Also invalidate size once ready so Leaflet measures tiles correctly
  useEffect(() => {
    if (ready) {
      const timer = setTimeout(() => map.invalidateSize(), 0)
      return () => clearTimeout(timer)
    }
  }, [ready, map])

  return ready ? children : null
}
